import clsx from 'clsx'
import {isEmpty} from 'lodash'

type ErrorSectionProps = {
  message?: string | string[]
  className?: string
}

export const ErrorSection = ({message, className}: ErrorSectionProps) => {
  if (!message || isEmpty(message)) return null

  const messages = Array.isArray(message) ? message : [message]

  return (
    <div
      className={clsx('bg-danger overflow-hidden', className)}
      style={{paddingLeft: '5px', borderRadius: '7px'}}
    >
      <div className='bg-danger-light p-3 rounded-start-1'>
        {messages.map((m, i) => (
          <div key={i}>
            <span className='fw-bold text-gray-800'>{m}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
